import { render } from "./StockQueueTab.vue?vue&type=template&id=c9e1edb0&scoped=true"
import script from "./StockQueueTab.vue?vue&type=script&lang=js"
export * from "./StockQueueTab.vue?vue&type=script&lang=js"

import "./StockQueueTab.vue?vue&type=style&index=0&id=c9e1edb0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9e1edb0"]])

export default __exports__